import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';

@Injectable({
  providedIn: 'root'
})
export class FollowPredictionService {
  private BASE_URL = environment.apiUrl + 'api';

  constructor(private http: HttpClient) { }

  followPrediction(action: any): Observable<any> {
    const url = `${this.BASE_URL}/follow/prediction`;
    return this.http.post<any>(url, {prediction_id: action.predictionId, user_id: action.userId});
  }

  unfollowPrediction(action: any): Observable<any> {
    const url = `${this.BASE_URL}/follow/prediction/unfollow`;
    return this.http.post<any>(url, {prediction_id: action.predictionId, user_id: action.userId})
  }

  getFollowedPredictions(userId: string): Observable<any> {
    const url = `${this.BASE_URL}/follow/prediction/${userId}/all`;
    return this.http.get<any>(url);
  }
}